module.exports = __webpack_public_path__ + "assets/speakingEnergy.0dfe3a9d.svg";